// extracted by mini-css-extract-plugin
export var message = "message-module--message--2gJCA";
export var content = "message-module--content--1COCj";
export var notice = "message-module--notice--1KW8Y";
export var success = "message-module--success--1pBqW";
export var warning = "message-module--warning--s7YsH";
export var error = "message-module--error--2RUZy";
export var item = "message-module--item--MNaTX";
export var zzz = "message-module--zzz--uiIas";